import {
  resolveOnlineVisitPageType,
  sendOnlineVisit,
  sendOnlineVisitKeepalive,
} from '@/utils/onlineVisit'

const ONLINE_VISIT_INTERVAL_MS = 30 * 1000
const ONLINE_VISIT_TIMER_KEY = '__onlineVisitTimer__'
const ONLINE_VISIT_UNLOAD_KEY = '__onlineVisitUnloadHandler__'
const ONLINE_VISIT_ROUTE_UNHOOK_KEY = '__onlineVisitRouteUnhook__'

const getRouteUrl = (route) => route?.fullPath || `${window.location.pathname || '/'}${window.location.search || ''}`

export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return

  const reportCurrentRoute = () => {
    if (document.visibilityState === 'hidden') return

    try {
      const route = nuxtApp.$router?.currentRoute?.value
      const url = getRouteUrl(route)
      sendOnlineVisit(resolveOnlineVisitPageType(url), {
        nuxtApp,
        url,
      })
    } catch (error) {
      // 忽略心跳上报错误，避免影响主流程
    }
  }

  // 避免热更新或重复初始化时产生多个定时器
  if (window[ONLINE_VISIT_TIMER_KEY]) {
    clearInterval(window[ONLINE_VISIT_TIMER_KEY])
  }

  const timerId = window.setInterval(() => {
    reportCurrentRoute()
  }, ONLINE_VISIT_INTERVAL_MS)

  window[ONLINE_VISIT_TIMER_KEY] = timerId

  // 首次进入先上报一次
  reportCurrentRoute()

  if (window[ONLINE_VISIT_ROUTE_UNHOOK_KEY]) {
    window[ONLINE_VISIT_ROUTE_UNHOOK_KEY]()
    window[ONLINE_VISIT_ROUTE_UNHOOK_KEY] = null
  }

  if (nuxtApp.$router?.afterEach) {
    window[ONLINE_VISIT_ROUTE_UNHOOK_KEY] = nuxtApp.$router.afterEach((to) => {
      const url = getRouteUrl(to)
      sendOnlineVisit(resolveOnlineVisitPageType(url), {
        nuxtApp,
        url,
      })
    })
  }

  const unloadHandler = () => {
    const route = nuxtApp.$router?.currentRoute?.value
    const url = getRouteUrl(route)
    sendOnlineVisitKeepalive(resolveOnlineVisitPageType(url), {
      url,
    })

    if (window[ONLINE_VISIT_TIMER_KEY]) {
      clearInterval(window[ONLINE_VISIT_TIMER_KEY])
      window[ONLINE_VISIT_TIMER_KEY] = null
    }

    if (window[ONLINE_VISIT_ROUTE_UNHOOK_KEY]) {
      window[ONLINE_VISIT_ROUTE_UNHOOK_KEY]()
      window[ONLINE_VISIT_ROUTE_UNHOOK_KEY] = null
    }

    if (window[ONLINE_VISIT_UNLOAD_KEY]) {
      window.removeEventListener('beforeunload', window[ONLINE_VISIT_UNLOAD_KEY])
      window.removeEventListener('pagehide', window[ONLINE_VISIT_UNLOAD_KEY])
      window[ONLINE_VISIT_UNLOAD_KEY] = null
    }
  }

  if (window[ONLINE_VISIT_UNLOAD_KEY]) {
    window.removeEventListener('beforeunload', window[ONLINE_VISIT_UNLOAD_KEY])
    window.removeEventListener('pagehide', window[ONLINE_VISIT_UNLOAD_KEY])
  }

  window[ONLINE_VISIT_UNLOAD_KEY] = unloadHandler
  window.addEventListener('beforeunload', unloadHandler)
  window.addEventListener('pagehide', unloadHandler)
})
